import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import NumberFormat from 'react-number-format';

import {
	setModoTela, initForm, salvarMedia, getListaMedia, importar
} from './metaCombustivelModeloActions';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';
import ReactExport from 'react-export-excel-fixed-xlsx';
import readXlsxFile from 'read-excel-file/web-worker';

class MetaCombustivelModeloForm extends Component {

	state = {

	}

	componentDidMount() {

		let initSeletor = () => {
			const fileSelector = document.createElement('input');
			fileSelector.setAttribute('type', 'file');
			fileSelector.addEventListener("change", async (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
						setError('Selecione apenas (.XLSX)');
						return;
					}

					let tabela = [];
					await readXlsxFile(file, { sheet: 1 }).then((rows) => {
						tabela = rows;
					});

					this.props.importar(tabela, { ...this.props.formularioValues });

					reader.readAsDataURL(file);

					initSeletor();

				}
			});

			this.fileSelector = fileSelector;
		};

		initSeletor();
		
	}

    componentWillMount() {
		this.props.getListaMedia(this.props.formularioValues.id);
    }

	componentWillUnmount() {
		this.props.getListaMedia(0);
    }

    render() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
			<>
				<ContentCard>					
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Field
									maxWidth={200}
									name='nome_marca'
									component={LabelAndInput}
									label='Marca' placeholder='Informe'
									cols='12 4 4 2'
									readOnly={'readOnly'} />
									
								<Field
									maxWidth={250}
									name='nome_modelo'
									component={LabelAndInput}
									label='Modelo' placeholder='Informe'
									cols='12 4 4 2'
									readOnly={'readOnly'} />

								<Field
									maxWidth={120}
									name='ano_modelo'
									component={LabelAndInput}
									label='Ano' placeholder='Informe'
									cols='12 4 4 2'
									readOnly={'readOnly'} />
								
								<Field
									maxWidth={300}
									name='nome_tipo_carroceria'
									component={LabelAndInput}
									label='Carroceria' placeholder='Informe'
									cols='12 4 4 3'
									readOnly={'readOnly'} />
								
								<Field
									maxWidth={120}
									name='protocolo'
									component={LabelAndInput}
									label='Protocolo' placeholder='Informe'
									cols='12 4 4 2'
									readOnly={'readOnly'} />
									
								<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>
									<ExcelFile
										filename={'Modelo de Importação'}
										element={
											<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}>
												<i class='fas fa-file-excel'></i> Modelo
											</a>
										}>
										<ExcelSheet data={this.props.listaPeso.map(peso => ({
											peso: `${peso.peso_inicial} - ${peso.peso_final}`
										}))} name='Modelo de Importação'>
											<ExcelColumn label='Peso' value='peso' />
											{this.props.listaRota.map((rota, i) => (
												<ExcelColumn label={rota.nome} value={`coluna_${i}`} />
											))}
										</ExcelSheet>
									</ExcelFile>

									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
										onClick={() => {											
											this.fileSelector.click();
										}}>
										<i class='fas fa-upload'></i> Importar
									</a>
									
									<a class='btn btn-app bg-warning' style={{ marginLeft: 2, minWidth: 75 }}
										onClick={() => {
											this.props.setModoTela('lista');
										}}>
										<i class='fas fa-arrow-left'></i> Voltar
									</a>
								</div>
							</Row>

							<div 
								style={{ 
									backgroundColor: '#1F3066',
									marginLeft: -8,
									marginRight: -8,
									marginBottom: -8,
									paddingTop: 1,
									paddingLeft: 8,
									paddingRight: 8,
									paddingBottom: 8,
									height: window.innerWidth < 768 ? '100%' : (
										window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
										: (
											window.innerWidth < 1799 
											? `${window.innerHeight - 190}px`
											: (
												window.innerWidth < 4000 
												? `${window.innerHeight - 190}px`
												: `${window.innerHeight - 190}px`
											)
										)
									)
								}}>
								<Table responsive border striped alturaFixa 
									maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
										window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
										: (
											window.innerWidth < 1799 
											? `${window.innerHeight - 190}px`
											: (
												window.innerWidth < 4000 
												? `${window.innerHeight - 190}px`
												: `${window.innerHeight - 190}px`
											)
										)
									)}>
									<THead>
										<Tr backgroundColor={'#1F3066'}
											color={'#ffffff'}
											height={47}>
											<Th maxWidth={200} width={200} paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Peso</Th>
											{this.props.listaRota.map(rota => (	
												<Th key={rota.id} maxWidth={200} width={200} paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>{rota.nome}</Th>
											))}
										</Tr>
									</THead>
									<TBody>
										{this.props.listaPeso.map((peso, i) => (
											<Tr key={peso.id}
												backgroundColor={this.state.linhaSelecionada == peso.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} 
												height={43} >
												<Td maxWidth={200} width={200} bold color={'#000'} alignCenter
													onClick={() => this.setState({ ...this.state, linhaSelecionada: peso.id })}>{peso.peso_inicial} - {peso.peso_final}</Td>
												{this.props.listaRota.map(rota => {

													const meta = this.props.listaMedia.filter(itemMeta => 
														itemMeta.id_meta_combustivel_rota == rota.id
														&& itemMeta.peso_inicial == peso.peso_inicial
														&& itemMeta.peso_final == peso.peso_final
													)[0];

													if (`${peso.id}-${rota.id}` == this.state.idAlteracao) {
														return (
															<Td maxWidth={200} width={200} key={rota.id} color={'#000'} alignCenter title={this.state.valorAlteracao || '0,00'}>
																<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
																	<NumberFormat 
																		className='form-control'
																		decimalSeparator={","}
																		decimalScale={2}
																		fixedDecimalScale={2}
																		thousandSeparator={'.'}
																		placeholder='0,00'
																		getInputRef={(el) => {
																			if (el) {
																				el.focus();
																			}
																		  }}
																		style={{
																			width: 80
																		}}
																		value={this.state.valorAlteracao}
																		onChange={data => {
																			this.setState({ ...this.state, valorAlteracao: data.target.value });
																		}} />
																	
																	<button
																		type='button'
																		className='btn btn-success'
																		style={{
																			height: 38,
																			width: 38
																		}}
																		onClick={() => {
																			let registro = null;
																			if (meta) {
																				registro = {
																					...meta
																				};
																			} else {
																				registro = {
																					id_meta_combustivel_modelo: this.props.formularioValues.id,
																					id_meta_combustivel_rota: rota.id,
																					peso_inicial: peso.peso_inicial,
																					peso_final: peso.peso_final,
																					media: 0
																				};
																			}
																			this.props.salvarMedia({
																				...registro,
																				media: this.state.valorAlteracao || '0'
																			});
																			this.setState({ idAlteracao: null, valorAlteracao: null });
																		}} >
																		<i className='fas fa-check'></i>
																	</button>
																	<button
																		type='button'
																		className='btn btn-danger'
																		style={{
																			height: 38,
																			width: 38
																		}}
																		onClick={() => {
																			this.setState({ idAlteracao: null, valorAlteracao: null });
																		}} >
																		<i className='fas fa-times'></i>
																	</button>
																</div>
															</Td>
														);
													} else {
														return (
															<Td maxWidth={200} width={200} key={rota.id} color={'#000'} alignCenter
																onClick={() => this.setState({ ...this.state, idAlteracao: `${peso.id}-${rota.id}`, valorAlteracao: null })}>
																{FormatUtils.formatarValorTela(meta ? meta.media : 0, 2)}
															</Td>
														);
													}
												})}
											</Tr>
										))}
									</TBody>
								</Table>
							</div>

						</ContentCardBody>
					</Form>
				</ContentCard>
			</>
        )
    }

	renderHistorico(readOnly) {
		
		return (
			<>
				<ContentCard>
					<ContentCardHeader>
						<label>Histórico</label>
					</ContentCardHeader>
					<ContentCardBody>
						<Table responsive>
							<THead>
								<Tr>
									<Th>Data/Hora</Th>
									<Th alignCenter>Operação</Th>
									<Th alignCenter>Registro</Th>
									<Th alignCenter>Anterior</Th>
									<Th alignCenter>Atual</Th>
									<Th alignCenter>Descrição</Th>
									<Th alignCenter>Usuário</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaHistorico.map(item => (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`} >
										<Td small >{DateFormat.formatarDataHoraSqlParaTela(item.datahora_historico)}</Td>
										<Td small alignCenter>{item.tipo}</Td>
										<Td small alignCenter>{item.nome}</Td>
										<Td small alignCenter>{(item.coluna == 'valor' || item.coluna == 'valor_autorizado' || item.coluna == 'percentual_desconto')
											? FormatUtils.formatarValorTela(item.anterior, 2) : (item.anterior || '')}</Td>
										<Td small alignCenter>{(item.coluna == 'valor' || item.coluna == 'valor_autorizado' || item.coluna == 'percentual_desconto')
											? FormatUtils.formatarValorTela(item.atual, 2) : (item.atual || '')}</Td>
										<Td small alignCenter>{item.descricao || ''}</Td>
										<Td small alignCenter>{item.nome_usuario || ''}</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			</>
		);
	}


}

MetaCombustivelModeloForm = reduxForm({form: 'metaCombustivelModeloForm', destroyOnUnmount: false})(MetaCombustivelModeloForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('metaCombustivelModeloForm')(state),
	registro: state.metaCombustivelModelo.registro,
	listaMedia: state.metaCombustivelModelo.listaMedia,
	listaRota: state.metaCombustivelModelo.listaRota,
	listaPeso: state.metaCombustivelModelo.listaPeso
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvarMedia, getListaMedia, importar
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaCombustivelModeloForm);